module.exports = __webpack_public_path__ + "files/d597e6652d0508d1b5361267e049125c.png";